import OrganizationSettingTable from '@/components/organization/cards/OrganizationSettingTable'
import Card from '@/components/shared/Card'
import { useAppStore } from '@/store/useAppStore'
import buildOrgPath from '@/utils/orgRoute'
import trpc from '@/utils/trpc'

interface Props {
  disabled: boolean
}

const OrganizationVaccinesCard = ({ disabled }: Props) => {
  const currentOrganization = useAppStore.use.currentOrganization().organization

  const vaccineListQuery = trpc.vaccine.list.useQuery(
    {
      organizationId: currentOrganization?.id || '',
    },
    {
      enabled: !!currentOrganization,
    }
  )

  return (
    <Card title="Vaccines">
      <OrganizationSettingTable
        addButtonTestID="add-vaccine-button"
        data={vaccineListQuery.data || []}
        disabled={disabled}
        editRoute={buildOrgPath(`/org-settings/${currentOrganization?.id}/vaccines`)}
      />
    </Card>
  )
}

export default OrganizationVaccinesCard
